import { render, staticRenderFns } from "./festivalCalendar.vue?vue&type=template&id=42b6960c&scoped=true&"
import script from "./festivalCalendar.vue?vue&type=script&lang=js&"
export * from "./festivalCalendar.vue?vue&type=script&lang=js&"
import style0 from "./festivalCalendar.vue?vue&type=style&index=0&id=42b6960c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b6960c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42b6960c')) {
      api.createRecord('42b6960c', component.options)
    } else {
      api.reload('42b6960c', component.options)
    }
    module.hot.accept("./festivalCalendar.vue?vue&type=template&id=42b6960c&scoped=true&", function () {
      api.rerender('42b6960c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/device/components/festivalCalendar.vue"
export default component.exports